import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { AdminProfile } from '@/types/auth.types';

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  admin: AdminProfile | null;
  isAuthenticated: boolean;

  setAuth: (data: { accessToken: string; refreshToken: string; admin: AdminProfile }) => void;
  setAccessToken: (token: string) => void;
  logout: () => void;
  hasPermission: (permission: string) => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      accessToken: null,
      refreshToken: null,
      admin: null,
      isAuthenticated: false,

      setAuth: ({ accessToken, refreshToken, admin }) =>
        set({ accessToken, refreshToken, admin, isAuthenticated: true }),

      setAccessToken: (token) => set({ accessToken: token }),

      logout: () =>
        set({ accessToken: null, refreshToken: null, admin: null, isAuthenticated: false }),

      hasPermission: (permission) => {
        const admin = get().admin;
        if (!admin) return false;
        const perms: string[] = admin.permissions ?? [];
        const role = admin.role;
        return (
          perms.includes('*:*') ||
          perms.includes(`${role}:*:*`) ||
          perms.includes(`${role}:${permission}`) ||
          perms.includes(permission)
        );
      },
    }),
    {
      name: 'tribe-admin-auth',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        admin: state.admin,
        isAuthenticated: state.isAuthenticated,
      }),
    },
  ),
);
